export const URL = '/api/sale'
